import React, { useState, useEffect } from 'react';
import './EscoComboBooleano.css';

const EscoComboBooleano = (props) => {
    const [estado, setEstado] = useState(props.valorInicial || null);

    const handleChangeEstado = (event) => {
        const nuevoEstado = event.target.value;
        setEstado(nuevoEstado);

        // Llama a la función prop proporcionada con el nuevo estado
        if (props.onChange) {
            props.onChange(nuevoEstado);
        }
    };

    // Utiliza useEffect para actualizar el estado cuando cambian las propiedades
    useEffect(() => {
        setEstado(props.valorInicial || null);
    }, [props.valorInicial]);

    return (
        <div className={`estado-combobox-container ${estado === null ? 'null' : estado === '0' ? 'si' : 'no'}`}>
            <select value={estado} onChange={handleChangeEstado}>
                <option value="null"></option>
                <option value="-1">Sí</option>
                <option value="0">No</option>
            </select>
        </div>
    );
};

export default EscoComboBooleano;
